import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Announcement bar',
    defaultMessage: 'Announcement bar',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  label: {
    id: 'announcementBar.label',
    defaultMessage: 'Label',
  },
  labelDescription: {
    id: 'announcementBar.labelDescription',
    defaultMessage: 'Bold prefix before the message (default: "News:").',
  },
  message: {
    id: 'announcementBar.message',
    defaultMessage: 'Message',
  },
  link: {
    id: 'announcementBar.link',
    defaultMessage: 'Link',
  },
  linkDescription: {
    id: 'announcementBar.linkDescription',
    defaultMessage: 'The whole bar becomes clickable.',
  },
  linkLabel: {
    id: 'announcementBar.linkLabel',
    defaultMessage: 'Link label',
  },
  linkLabelDescription: {
    id: 'announcementBar.linkLabelDescription',
    defaultMessage: 'Text at the right end (default: "Learn more").',
  },
  closeable: {
    id: 'announcementBar.closeable',
    defaultMessage: 'Closeable',
  },
  closeableDescription: {
    id: 'announcementBar.closeableDescription',
    defaultMessage: 'Shows an X so visitors can dismiss the bar.',
  },
});

/**
 * Schema do bloco Announcement bar — faixa de novidade abaixo do header
 * (pedido da UNESCO, 2026-09). Texto, link e rótulos são todos editáveis;
 * `label` e `linkLabel` vazios caem em defaults i18n — ver AnnouncementBarBody.
 */
const AnnouncementBarSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['label', 'message', 'link', 'linkLabel', 'closeable'],
    },
  ],
  properties: {
    label: {
      title: intl.formatMessage(messages.label),
      description: intl.formatMessage(messages.labelDescription),
      type: 'string',
    },
    message: {
      title: intl.formatMessage(messages.message),
      type: 'string',
      widget: 'textarea',
    },
    link: {
      title: intl.formatMessage(messages.link),
      description: intl.formatMessage(messages.linkDescription),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: true,
    },
    linkLabel: {
      title: intl.formatMessage(messages.linkLabel),
      description: intl.formatMessage(messages.linkLabelDescription),
      type: 'string',
    },
    closeable: {
      title: intl.formatMessage(messages.closeable),
      description: intl.formatMessage(messages.closeableDescription),
      type: 'boolean',
    },
  },
  required: ['message'],
});

export default AnnouncementBarSchema;
